export interface ConfirmationOptions {
  title?: string
  label?: string
  intent?: string
  icon?: string
  // A URL whose response carries <turbo-frame id="app_confirmation_body">: the
  // dialog loads it between the message and the buttons, and on accept copies
  // the fields of the form inside it onto the pending submission.
  src?: string
  // The form Turbo is holding for this confirmation, when there is one.
  form?: HTMLFormElement
}

export interface ConfirmationRequest extends ConfirmationOptions {
  message: string
  resolve: (answer: boolean) => void
}

export function confirmationOptions(element?: HTMLElement | null): ConfirmationOptions {
  return {
    title: element?.dataset.confirmTitle,
    label: element?.dataset.confirmLabel,
    intent: element?.dataset.confirmIntent,
    icon: element?.dataset.confirmIcon,
  }
}

export function requestConfirmation(message: string, options: ConfirmationOptions = {}): Promise<boolean> {
  return new Promise((resolve) => {
    const event = new CustomEvent<ConfirmationRequest>('confirmation:request', {
      cancelable: true,
      detail: { ...options, message, resolve },
    })
    document.dispatchEvent(event)
    if (event.defaultPrevented) return
    // Preserve confirmation on layouts without the shared component or before Stimulus connects.
    // A confirmation that needs a body cannot be answered by the browser prompt: fail closed.
    resolve(options.src ? false : window.confirm(message))
  })
}
